module.exports = __webpack_public_path__ + "c3c84f301ce6b862025d57ecde0036fe.svg";